import * as React from "react";
import { Item, Header } from "semantic-ui-react";

import { MobileClinicDetails } from "../models";

import { MobileClinicAppointmentActions } from "./MobileClinicAppointmentActions";

interface Props {
    clinic: MobileClinicDetails;
}

export const MobileClinicAppointments: React.FC<Props> = (props) => {
    return (
        <>
            <Header as="h2">Employees in clinic</Header>
            <Item.Group divided className="mobile-clinic-employees-list">
                {props.clinic.appointments.map(a =>
                    (<MobileClinicAppointmentActions
                        appointment={a}
                        key={a.id}
                        clinicId={props.clinic.id}
                    />))}
            </Item.Group>
        </>);
};
